<app-loading-wrapper [loading]="saving">
    <div *ngIf="questions && formGroup">
        <form *ngIf="questions" [formGroup]="formGroup">
            <mat-card>
                <mat-card-title>Batch Close Grading Schedule</mat-card-title>

                <div class="row">
                    <div class="small-12 medium-12 large-4 columns">
                        <app-text [alias]="'schedule-batch-process'"></app-text>
                    </div>
                    <div class="small-12 medium-12 large-4 columns">
                        <app-question [question]="questions.termCode"></app-question>
                    </div>
                    <div class="small-12 medium-12 large-4 columns">
                        <app-button-list>
                            <app-button [loading]="saving" *ngIf="onShowSaveButton()" (clickedEvent)="onSaveData()">Save</app-button>
                            <app-button [loading]="saving" (clickedEvent)="onCancel()">Cancel</app-button>
                        </app-button-list>
                    </div>
                </div>

            </mat-card>


        </form>

    </div>
</app-loading-wrapper>
